module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#share",
      toString: function () {
        return this.url;
      }
    }